import { render, staticRenderFns } from "./CustomFooterColumnTheme0.vue?vue&type=template&id=248e3fc6&scoped=true"
import script from "./CustomFooterColumnTheme0.vue?vue&type=script&lang=js"
export * from "./CustomFooterColumnTheme0.vue?vue&type=script&lang=js"
import style0 from "./CustomFooterColumnTheme0.vue?vue&type=style&index=0&id=248e3fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e3fc6",
  null
  
)

export default component.exports